const SMOKEBALL_CONVERSATION_CACHE_STORAGE_KEY = "SmokeballConversationCache";
const MAX_CACHE_LENGTH = 10;

type TConversationIdCache = {
  version: 1;
  id: "conversation_id_cache";
  // allows duplicates but latest should win
  cache: {
    conversationId: string;
    matterId?: string | null;
  }[];
};

const initConversationIdCache = (): TConversationIdCache => ({
  version: 1,
  id: "conversation_id_cache",
  cache: [],
});

const isConversationIdCache = (thing: unknown): thing is TConversationIdCache => {
  const maybeCache = thing as TConversationIdCache;
  if (
    !maybeCache ||
    typeof maybeCache !== "object" ||
    maybeCache.id != "conversation_id_cache" ||
    typeof maybeCache.cache !== "object"
  ) {
    return false;
  }

  return true;
};

const retrieveConversationIdCache = () => {
  let maybeCache: TConversationIdCache | undefined;

  try {
    const key = localStorage.getItem(SMOKEBALL_CONVERSATION_CACHE_STORAGE_KEY);
    if (key) {
      maybeCache = JSON.parse(key);
    }
  } catch {
    // pass
  }

  if (!isConversationIdCache(maybeCache)) {
    maybeCache = initConversationIdCache();
  }

  return maybeCache; // not maybe any more
};

// TODO: This likely should be a key value store of conversationId => matterId, faster lookups and less likely to have duplicate records for the one conversation id. 
// We also likely don't wanna use a localStorage cache for this, as its unreliable for different users/outlooks
export const associateMatterIdInConversationCache = (conversationId: string | null, matterId: string | null) => {
  if (!conversationId) {
    return;
  }

  const idCache = retrieveConversationIdCache();
  const cache = idCache.cache;

  cache.push({ conversationId, matterId });

  idCache.cache = cache.slice(-1 * MAX_CACHE_LENGTH);

  localStorage.setItem(SMOKEBALL_CONVERSATION_CACHE_STORAGE_KEY, JSON.stringify(idCache));
};

export const getMatterIdFromConversationCache = (conversationId: string): string | null => {
  const idCache = retrieveConversationIdCache();
  const found = [...idCache.cache].reverse().find((i) => i.conversationId === conversationId);
  return found?.matterId || null;
};
